import * as _ from 'lodash';
import { useContext } from 'react';
import { IDonorSearchResult } from '@nkr/models/index';
import { DonorSearchContext } from './context';
import { TableWrapper } from './styles';
import ListRow from './list-row';

interface IProps {
    data: IDonorSearchResult[],
    isInDonorShield: boolean,
    filtered: boolean
}

const List = (props: IProps) => {
    const context = useContext(DonorSearchContext);

    return (
        <>
            <TableWrapper striped style={{ marginBottom: 0 }}>
                <thead>
                    <tr>
                        <th style={{ width: '1%' }}></th>
                        <th style={{ width: '4%' }}>Row #</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Age</th>
                        <th>Alias</th>
                        <th>Gender</th>
                        <th>Email</th>
                        <th>Date<br />Registered</th>
                        <th>Date<br />Donated</th>
                        <th>DASH<br />Registration</th>
                        <th>NKR<br />Swap Donor</th>

                        {props.isInDonorShield && (
                            <th>Donor Shield<br />Direct</th>
                        )}

                        <th>Wage &amp; Expense<br />Reimbursement</th>
                        <th>Donor<br />Follow-Up</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.length == 0 && props.filtered == false && (
                        <tr>
                            <td colSpan={15} className='text-center'>
                                No records at this time, use the search filters above to look for donor records including in DASH, Donor Shield Direct, and Donor Follow-Up...
                            </td>
                        </tr>
                    )}

                    {props.data.length == 0 && props.filtered && (
                        <tr>
                            <td colSpan={15} className='text-center'>
                                We couldn't find any records that match your criteria...
                            </td>
                        </tr>
                    )}

                    {props.data.map((item, index) =>
                        <ListRow
                            key={index}
                            index={index}
                            data={item}
                            isInDonorShield={props.isInDonorShield}
                        />
                    )}
                </tbody>
            </TableWrapper>
        </>
    );
}

export default List;